import { ActionBuilder } from '@cuatroochenta/co-redux-builders';

export default ActionBuilder.build({
    dispatchResetSendToProccessReducer: () => ( {} ),
    dispatchChangeDate: (newDate: Date) => ( newDate ),
    dispatchResetDate: () => ({}),
    dispatchSetFile: (newUrl: string) => ( newUrl ),
});
